import { insertHabit, getHabits, getAllHabitsByUserId, deleteHabit } from '../util/api';

export const INSERT_HABIT_REQUEST = 'app/habits/INSERT_HABIT_REQUEST';
export const INSERT_HABIT_SUCCESS = 'app/habits/INSERT_HABIT_SUCCESS';
export const INSERT_HABIT_ERROR = 'app/habits/INSERT_HABIT_ERROR';

export const FETCH_HABITS_REQUEST = 'app/habits/FETCH_HABITS_REQUEST';
export const FETCH_HABITS_SUCCESS = 'app/habits/FETCH_HABITS_SUCCESS';
export const FETCH_HABITS_ERROR = 'app/habits/FETCH_HABITS_ERROR';

export const FETCH_ALL_HABITS_REQUEST = 'app/habits/FETCH_ALL_HABITS_REQUEST';
export const FETCH_ALL_HABITS_SUCCESS = 'app/habits/FETCH_ALL_HABITS_SUCCESS';
export const FETCH_ALL_HABITS_ERROR = 'app/habits/FETCH_ALL_HABITS_ERROR';

export const DELETE_HABIT_REQUEST = 'app/habits/DELETE_HABIT_REQUEST';
export const DELETE_HABIT_SUCCESS = 'app/habits/DELETE_HABIT_SUCCESS';
export const DELETE_HABIT_ERROR = 'app/habits/DELETE_HABIT_ERROR';

export const SAVE_HABITS_REQUEST = 'app/habits/SAVE_HABITS_REQUEST';
export const SAVE_HABITS_SUCCESS = 'app/habits/SAVE_HABITS_SUCCESS';
export const SAVE_HABITS_ERROR = 'app/habits/SAVE_HABITS_ERROR';

export const initialState = {
  isSubmitting: false,
  submitSuccess: false,
  error: null,
  habits: [],
  isFetching: false,
  fetchError: null,
  allHabits: [],
  isFetchingAllHabits: false,
  fetchAllHabitsError: null,
  isDeletingHabit: false,
  deleteHabitSuccess: false,
  deleteHabitError: null,
  isSavingHabits: false,
  saveHabitsSuccess: false,
  saveHabitsError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case INSERT_HABIT_REQUEST:
      return { ...state, isSubmitting: true, error: null };
    case INSERT_HABIT_SUCCESS:
      // Optimistically add the new habit to allHabits
      const newHabit = payload;
      const updatedAllHabitsAfterInsert = newHabit
        ? [...state.allHabits, newHabit]
        : state.allHabits;
      return {
        ...state,
        isSubmitting: false,
        submitSuccess: true,
        error: null,
        allHabits: updatedAllHabitsAfterInsert,
      };
    case INSERT_HABIT_ERROR:
      return { ...state, isSubmitting: false, submitSuccess: false, error: payload };
    case FETCH_HABITS_REQUEST:
      return { ...state, isFetching: true, fetchError: null };
    case FETCH_HABITS_SUCCESS:
      return { ...state, isFetching: false, habits: payload, fetchError: null };
    case FETCH_HABITS_ERROR:
      return { ...state, isFetching: false, fetchError: payload };
    case FETCH_ALL_HABITS_REQUEST:
      return { ...state, isFetchingAllHabits: true, fetchAllHabitsError: null };
    case FETCH_ALL_HABITS_SUCCESS:
      return {
        ...state,
        isFetchingAllHabits: false,
        allHabits: payload,
        fetchAllHabitsError: null,
      };
    case FETCH_ALL_HABITS_ERROR:
      return { ...state, isFetchingAllHabits: false, fetchAllHabitsError: payload };
    case DELETE_HABIT_REQUEST:
      return { ...state, isDeletingHabit: true, deleteHabitError: null };
    case DELETE_HABIT_SUCCESS:
      // Optimistically remove the habit from allHabits
      const deletedHabitId = payload;
      const updatedAllHabitsAfterDelete = deletedHabitId
        ? state.allHabits.filter(habit => habit.id !== deletedHabitId)
        : state.allHabits;
      return {
        ...state,
        isDeletingHabit: false,
        deleteHabitSuccess: true,
        deleteHabitError: null,
        allHabits: updatedAllHabitsAfterDelete,
      };
    case DELETE_HABIT_ERROR:
      return {
        ...state,
        isDeletingHabit: false,
        deleteHabitSuccess: false,
        deleteHabitError: payload,
      };
    case SAVE_HABITS_REQUEST:
      return { ...state, isSavingHabits: true, saveHabitsError: null, saveHabitsSuccess: false };
    case SAVE_HABITS_SUCCESS:
      return { ...state, isSavingHabits: false, saveHabitsSuccess: true, saveHabitsError: null };
    case SAVE_HABITS_ERROR:
      return {
        ...state,
        isSavingHabits: false,
        saveHabitsSuccess: false,
        saveHabitsError: payload,
      };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const insertHabitRequest = () => ({ type: INSERT_HABIT_REQUEST });
export const insertHabitSuccess = habit => ({ type: INSERT_HABIT_SUCCESS, payload: habit });
export const insertHabitError = error => ({ type: INSERT_HABIT_ERROR, payload: error });

export const fetchHabitsRequest = () => ({ type: FETCH_HABITS_REQUEST });
export const fetchHabitsSuccess = habits => ({ type: FETCH_HABITS_SUCCESS, payload: habits });
export const fetchHabitsError = error => ({ type: FETCH_HABITS_ERROR, payload: error });

export const fetchAllHabitsRequest = () => ({ type: FETCH_ALL_HABITS_REQUEST });
export const fetchAllHabitsSuccess = habits => ({
  type: FETCH_ALL_HABITS_SUCCESS,
  payload: habits,
});
export const fetchAllHabitsError = error => ({ type: FETCH_ALL_HABITS_ERROR, payload: error });

export const deleteHabitRequest = () => ({ type: DELETE_HABIT_REQUEST });
export const deleteHabitSuccess = habitId => ({ type: DELETE_HABIT_SUCCESS, payload: habitId });
export const deleteHabitError = error => ({ type: DELETE_HABIT_ERROR, payload: error });

export const saveHabitsRequest = () => ({ type: SAVE_HABITS_REQUEST });
export const saveHabitsSuccess = () => ({ type: SAVE_HABITS_SUCCESS });
export const saveHabitsError = error => ({ type: SAVE_HABITS_ERROR, payload: error });

// ================ Thunks ================ //

export const insertHabitData = state => {
  return {
    isSubmitting: state.habits.isSubmitting,
    submitSuccess: state.habits.submitSuccess,
    error: state.habits.error,
  };
};

export const fetchHabitsData = state => {
  return {
    habits: state.habits.habits,
    isFetching: state.habits.isFetching,
    fetchError: state.habits.fetchError,
  };
};

export const fetchAllHabitsData = state => {
  return {
    allHabits: state.habits.allHabits,
    isFetchingAllHabits: state.habits.isFetchingAllHabits,
    fetchAllHabitsError: state.habits.fetchAllHabitsError,
  };
};

export const deleteHabitData = state => {
  return {
    isDeletingHabit: state.habits.isDeletingHabit,
    deleteHabitSuccess: state.habits.deleteHabitSuccess,
    deleteHabitError: state.habits.deleteHabitError,
  };
};

export const saveHabitsData = state => {
  return {
    isSavingHabits: state.habits.isSavingHabits,
    saveHabitsSuccess: state.habits.saveHabitsSuccess,
    saveHabitsError: state.habits.saveHabitsError,
  };
};

export const insertHabitAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(insertHabitRequest());
  try {
    const result = await insertHabit(params);
    // Optimistically update allHabits with the new habit
    if (result && result.habit) {
      dispatch(insertHabitSuccess(result.habit));
    } else {
      dispatch(insertHabitSuccess(null));
    }
    return result;
  } catch (error) {
    console.error('Error inserting habit:', error);
    dispatch(insertHabitError(error.message || 'Failed to submit habit'));
    throw error;
  }
};

export const fetchHabitsAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchHabitsRequest());
  try {
    const result = await getHabits(params);
    dispatch(fetchHabitsSuccess(result.habits || []));
    return result;
  } catch (error) {
    console.error('Error fetching habits:', error);
    dispatch(fetchHabitsError(error.message || 'Failed to fetch habits'));
    throw error;
  }
};

export const fetchAllHabitsAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchAllHabitsRequest());
  try {
    const result = await getAllHabitsByUserId(params);
    dispatch(fetchAllHabitsSuccess(result.habits || []));
    return result;
  } catch (error) {
    console.error('Error fetching all habits:', error);
    dispatch(fetchAllHabitsError(error.message || 'Failed to fetch all habits'));
    throw error;
  }
};

export const deleteHabitAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(deleteHabitRequest());
  try {
    const { habitId } = params;
    const result = await deleteHabit(params);
    dispatch(deleteHabitSuccess(habitId));
    return result;
  } catch (error) {
    console.error('Error deleting habit:', error);
    dispatch(deleteHabitError(error.message || 'Failed to delete habit'));
    throw error;
  }
};

export const saveHabitsAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(saveHabitsRequest());
  try {
    const { userId, date, selectedHabits } = params;

    if (!userId || !date) {
      throw new Error('userId and date are required');
    }

    // Get current state to access allHabits
    const state = getState();
    const { allHabits } = state.habits;

    // Get existing habits for this date
    const existingHabitsForDate = allHabits.filter(habit => habit.date === date);

    // Get habit type IDs that are currently saved
    const existingHabitTypeIds = existingHabitsForDate.map(habit => parseInt(habit.habit));

    // Find habits to delete (exist in DB but not in selectedHabits)
    const habitsToDelete = existingHabitsForDate.filter(
      habit => !selectedHabits.includes(parseInt(habit.habit))
    );

    // Find habits to insert (in selectedHabits but not in DB)
    const habitsToInsert = selectedHabits.filter(
      habitId => !existingHabitTypeIds.includes(habitId)
    );

    // Delete habits that are no longer selected (call API directly to avoid multiple state updates)
    const deletePromises = habitsToDelete.map(habit =>
      deleteHabit({ userId, date, habitId: habit.id })
    );

    // Insert new habits (call API directly to avoid multiple state updates)
    const insertPromises = habitsToInsert.map(habitId =>
      insertHabit({ userId, date, habit: habitId.toString() })
    );

    // Execute all operations
    await Promise.all([...deletePromises, ...insertPromises]);

    // Refresh the habits list after saving
    dispatch(fetchAllHabitsAction({ userId }));

    dispatch(saveHabitsSuccess());
    return { success: true };
  } catch (error) {
    console.error('Error saving habits:', error);
    dispatch(saveHabitsError(error.message || 'Failed to save habits'));
    throw error;
  }
};
